
import React, { useEffect, useState } from "react";
import {DEFAULT_PROFILE_IMG} from '../../constants/common'
import "../../styles/Profile.css";
import Footer from "../../layouts/Footer";
import Navbar from "../../layouts/Navbar";
import { Link, useNavigate } from "react-router-dom";
import loginImg from "../../assets/loginImage.jpeg"
import axios from "axios";
import icon from "../../assets/icon.png"
const ProviderProfile = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [licenseNo, setLicense] = useState("")
  const [token, setToken] = useState("");
  const [profileImage, setProfileImage] = useState("")

  const ProfileDetails = async (token) => {
    // e.preventDefault();

    try {
      const response = await axios.get(
        "https://yelospace.com/api/provider-profile",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.logresponse.data.response);
      const userDetailsDTO = response.data.response;
      setEmail(userDetailsDTO.email);
      setFirstName(userDetailsDTO.firstName);
      setLastName(userDetailsDTO.lastName);
      setMobile(userDetailsDTO.mobile);
      setLicense(userDetailsDTO.licenseNo);
      setProfileImage(userDetailsDTO.profileImage)
    } catch (error) {
      //console.logerror);
    }
  };

  useEffect(() => {
    let data = localStorage.getItem("data");
    data = JSON.parse(data);
    setToken(data.jwt);
    ProfileDetails(data.jwt);
  }, []);
  return (
    <>
    <Navbar/>
    <div className="profile-container">
        <div className="left-panel">
          <img src={loginImg} alt="Left Panel Image" />
        </div>
        <div className="right">

          <div className="profile-details">
          <div className="d-flex justify-content-center w-100 mt-4">
          <h3>Provider Profile</h3>
          </div>
          <div className="w-100 d-flex justify-content-center">
            <div className="user-info">
              <div className="user-avatar mt-3">
              <img src={profileImage ||  icon} alt="User Avatar" />
              </div>
              <div className="user-text">
                <p>
                  <strong>Name:</strong> {firstName} {lastName}
                </p>
                <p>
                  <strong>Email:</strong> {email}
                </p>
                <p>
                  <strong>Mobile:</strong> {mobile}
                </p>
                <p>
                <strong>License No:</strong> {licenseNo}
                </p>
              </div>
            </div>
            </div>
          </div>
          <div className="d-flex justify-content-center w-100">
            <Link to="/provider-edit-profile">
              <button type="submit" className="submit-btn">
                Edit Profile
              </button>
            </Link>
          </div>
        </div>
      </div>
      </>
    
  );
};

export default ProviderProfile;

